import React from "react";
import { Card, CardHeader, CardContent, Autocomplete, TextField, Chip, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

export default function ApplicationSection({
  appsLabels,
  appsLoading,
  formData,
  setFormData,
}) {
  const { t } = useTranslation("products");
  return (
    <Card variant="outlined" sx={{ mb: 2 }}>
      <CardHeader
        title={t("form.applicationTitle")}
        sx={{ pb: 0.5, "& .MuiCardHeader-title": { fontSize: 16, fontWeight: 600 } }}
      />
      <CardContent sx={{ pt: 2 }}>
        <Autocomplete
          multiple
          freeSolo
          options={appsLabels}
          filterSelectedOptions
          loading={appsLoading}
          loadingText={t("form.loading")}
          value={Array.isArray(formData.aplicacao) ? formData.aplicacao : []}
          onChange={(_, newVal) => {
            const norm = (s) => String(s || "").trim();
            const cleaned = (newVal || []).map(norm).filter(Boolean);
            setFormData((prev) => ({ ...prev, aplicacao: cleaned }));
          }}
          renderTags={(value, getTagProps) =>
            value.map((option, index) => (
              <Chip {...getTagProps({ index })} key={`${option}-${index}`} label={option} size="small" />
            ))
          }
          renderInput={(params) => (
            <TextField
              {...params}
              label={t("form.applicationsListLabel")}
              placeholder={
                appsLoading
                  ? t("form.applicationsListPlaceholderLoading")
                  : t("form.applicationsListPlaceholder")
              }
            />
          )}
        />
        <Typography variant="caption" color="text.secondary" sx={{ mt: 1, display: "block" }}>
          {t("form.applicationTip")}
        </Typography>
      </CardContent>
    </Card>
  );
}
